// Mock data for Natascha van Dam - Travel Counsellor website
// NOTE: This is placeholder/mock data for the frontend-only build.

export const site = {
  name: "Natascha van Dam",
  role: "Travel Counsellor",
  tagline: "Jouw persoonlijk reisadviseur",
  phone: "06 18314018",
  email: "natascha.vandam@travelcounsellors.nl",
  region: "Regio Nederland. Persoonlijk advies, waar je ook woont",
  socials: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    whatsapp: "https://wa.me/31618314018",
  },
  photos: {
    // Professional office photo (used in hero)
    office: "https://customer-assets.emergentagent.com/job_vakantie-upgrade/artifacts/jbr10i5j_Profiel%20Natascha.jpeg",
    // Personal portrait (used in about)
    portrait: "https://customer-assets.emergentagent.com/job_vakantie-upgrade/artifacts/nzqnyii4_NvD.png",
  },
};

export const navLinks = [
  { label: "Over mij", href: "#over-mij" },
  { label: "Diensten", href: "#diensten" },
  { label: "Bestemmingen", href: "#bestemmingen" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const stats = [
  { value: "24+", label: "Jaar ervaring" },
  { value: "2.500+", label: "Reizen geboekt" },
  { value: "100%", label: "Op maat gemaakt" },
  { value: "9,6", label: "Gemiddelde beoordeling" },
];

export const services = [
  {
    icon: "Map",
    title: "Rondreizen op maat",
    text: "Van een culturele ontdekkingsreis tot een avontuurlijke roadtrip, volledig samengesteld rondom jouw wensen en tempo.",
  },
  {
    icon: "Building2",
    title: "Stedentrips",
    text: "Een lang weekend Rome, Barcelona of New York? Ik regel de leukste hotels op de mooiste plekken.",
  },
  {
    icon: "Sun",
    title: "Zon, strand & all-inclusive",
    text: "Even helemaal ontspannen zonder ergens aan te denken. De perfecte plek voor jouw ideale zonvakantie.",
  },
  {
    icon: "Heart",
    title: "Huwelijksreizen",
    text: "Een onvergetelijke honeymoon die net zo bijzonder is als jullie liefde. Romantisch, luxe en persoonlijk.",
  },
  {
    icon: "Ship",
    title: "Cruises",
    text: "Ontdek meerdere bestemmingen in één reis. Van de Middellandse Zee tot de fjorden van Noorwegen.",
  },
  {
    icon: "Users",
    title: "Familie- & groepsreizen",
    text: "Reizen met het hele gezin of een grote groep? Ik houd rekening met ieders wensen en budget.",
  },
];

export const destinations = [
  {
    name: "Santorini",
    country: "Griekenland",
    text: "Witte dorpjes, blauwe koepels en de mooiste zonsondergangen van de Middellandse Zee.",
    image: "https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxTYW50b3JpbmklMjBHcmVlY2V8ZW58MHx8fHwxNzgxODU3MjExfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Bali",
    country: "Indonesië",
    text: "Groene rijstvelden, tempels en tropische stranden. Puur genieten op het eiland der goden.",
    image: "https://images.unsplash.com/photo-1555400038-63f5ba517a47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxCYWxpJTIwcmljZSUyMHRlcnJhY2VzfGVufDB8fHx8MTc4MTg1NzIxMXww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Venetië",
    country: "Italië",
    text: "Romantische grachten, historische pleinen en de allerbeste Italiaanse keuken.",
    image: "https://images.unsplash.com/photo-1520175480921-4edfa2983e0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Malediven",
    country: "Indische Oceaan",
    text: "Overwater villa's boven turquoise water. De ultieme droombestemming voor luxe en rust.",
    image: "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxNYWxkaXZlc3xlbnwwfHx8fDE3ODE4NzgyODV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Kyoto",
    country: "Japan",
    text: "Eeuwenoude tempels, kersenbloesem en een cultuur die je nergens anders vindt.",
    image: "https://images.unsplash.com/photo-1545569341-9eb8b30979d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxKYXBhbnxlbnwwfHx8fDE3ODMwNDUzMjZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Amalfikust",
    country: "Italië",
    text: "Kleurrijke kustdorpjes tegen de rotsen, azuurblauwe zee en la dolce vita op zijn best.",
    image: "https://images.unsplash.com/photo-1583844056361-4418a8f2a985?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxBbWFsZmklMjBDb2FzdHxlbnwwfHx8fDE3ODI4NTEzNzJ8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const reviews = [
  {
    name: "Sandra & Peter",
    trip: "Rondreis Italië",
    rating: 5,
    text: "Natascha heeft onze reis tot in de puntjes verzorgd. Alles klopte, van de hotels tot de kleine tips onderweg. Wij boeken nooit meer zelf!",
  },
  {
    name: "Familie De Vries",
    trip: "All-inclusive Turkije",
    rating: 5,
    text: "Met drie kinderen een vakantie boeken is lastig, maar Natascha dacht overal aan. Persoonlijk, meedenkend en gewoon heel fijn.",
  },
  {
    name: "Mark J.",
    trip: "Huwelijksreis Malediven",
    rating: 5,
    text: "Onze honeymoon was werkelijk perfect. Niets was te veel gevraagd. Bedankt voor deze onvergetelijke ervaring!",
  },
  {
    name: "Ingrid B.",
    trip: "Stedentrip Barcelona",
    rating: 5,
    text: "Snel geregeld, top hotel op een geweldige locatie en scherpe prijs. Precies wat ik zocht. Aanrader!",
  },
];

export const faqs = [
  {
    q: "Wat kost het om een reis via jou te boeken?",
    a: "Mijn advies en persoonlijke begeleiding zijn kosteloos. Ik boek je reis tegen dezelfde of vaak zelfs scherpere prijzen dan je online vindt, maar dan met een vast aanspreekpunt en volledige ontzorging.",
  },
  {
    q: "Kan ik ook een reis op maat laten samenstellen?",
    a: "Absoluut, dat is juist mijn specialiteit. We bespreken jouw wensen, budget en droombestemming en ik stel een reis samen die volledig bij jou past.",
  },
  {
    q: "Ben ik verzekerd als ik bij jou boek?",
    a: "Ja. Als Travel Counsellor werk ik onder een gerenommeerde organisatie met garantieregeling, zodat jouw geld en vakantie altijd beschermd zijn.",
  },
  {
    q: "Kan ik je ook 's avonds of in het weekend bereiken?",
    a: "Zeker. Ik ben flexibel bereikbaar en denk met je mee wanneer het jou uitkomt, ook buiten kantooruren en tijdens je reis.",
  },
  {
    q: "Boek je ook last-minute reizen?",
    a: "Ja, ook voor een spontane trip ben je bij mij aan het juiste adres. Neem gerust contact op en we kijken naar de mogelijkheden.",
  },
  {
    q: "Wat gebeurt er als er iets misgaat tijdens mijn reis?",
    a: "Dan sta ik voor je klaar. Één telefoontje en ik regel het. Dat is nu juist het voordeel van een persoonlijk reisadviseur.",
  },
];
